import { render, staticRenderFns } from "./AppointmentDepositSetting.vue?vue&type=template&id=66e2d664"
import script from "./AppointmentDepositSetting.vue?vue&type=script&lang=js"
export * from "./AppointmentDepositSetting.vue?vue&type=script&lang=js"
import style0 from "./AppointmentDepositSetting.vue?vue&type=style&index=0&id=66e2d664&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports